<ion-list lines="none">
  <ion-item>
    <ion-icon src="/assets/icons/24px/member.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Why Cameras Matter</h3>
      </ion-text>

      <ion-text color="black">
        <p>Cameras help with non-verbal communication like body language and eye contact</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/lock.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Browser Permissions</h3>
      </ion-text>

      <ion-text color="black">
        <p>Allow Browser permission by clicking on the Lock icon to the left of the URL</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item *ngIf="osSecurityPreferences">
    <ion-icon src="/assets/icons/24px/lock.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>OS Permissions</h3>
      </ion-text>

      <ion-text color="black">
        <p>
          {{ osSecurityPreferences }}
        </p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>
